'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const HeatmapGroupViewModel=require('../../../dist-es6/client/viewModels/heatmapGroupViewModel');
const PseudoGroup=require('../../../dist-es6/client/domain/pseudoGroup');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const MaxDepth=2;let

HeatmapService=function(_BaseService){_inherits(HeatmapService,_BaseService);_createClass(HeatmapService,null,[{key:'$inject',get:function()
{return[]}}]);

function HeatmapService(){_classCallCheck(this,HeatmapService);return _possibleConstructorReturn(this,
_BaseService.call(this));
}HeatmapService.prototype.

getMaxAvailableDepth=function getMaxAvailableDepth(group){var _this2=this;let maxDepth=arguments.length>1&&arguments[1]!==void 0?arguments[1]:MaxDepth;let currentDepth=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0;
maxDepth=Math.min(maxDepth,MaxDepth);

const{children:children}=group;
return children.length&&currentDepth<maxDepth?
_.max(children.map(function(child){return _this2.getMaxAvailableDepth(child,maxDepth,currentDepth+1)})):
currentDepth;
};HeatmapService.prototype.

getLeafGroups=function getLeafGroups(groupTree){
if(_.exists(this._lastGroupTreeForLeafGroups)&&this._lastGroupTreeForLeafGroups===groupTree){
return this._lastLeafGroupsResult;
}

const maxAvailableDepth=this.getMaxAvailableDepth(groupTree);
const leafGroups=[];
_walkTreeFromRoot(groupTree,function(group,currentDepth,currentPath){
if(currentDepth!==maxAvailableDepth)
return;

leafGroups.push(group);
});

this._lastGroupTreeForLeafGroups=groupTree;
this._lastLeafGroupsResult=leafGroups;

return this._lastLeafGroupsResult;
};HeatmapService.prototype.

setColSpansForLeafGroups=function setColSpansForLeafGroups(groupTree,numLeafColumns){
const leafGroups=this.getLeafGroups(groupTree);
for(const groupIndex in leafGroups){
leafGroups[groupIndex].colSpan=numLeafColumns[groupIndex];
};
};HeatmapService.prototype.

determineColSpansForLeafGroups=function determineColSpansForLeafGroups(groupTree,personHeight,heatmapHeight){let filteredPersonIds=arguments.length>3&&arguments[3]!==void 0?arguments[3]:null;
const useFilter=_.exists(filteredPersonIds)&&groupTree.aggregatePersons.length!==filteredPersonIds.length;

let leafColSpans=[];
let filteredLeafColSpans=[];
for(const group of this.getLeafGroups(groupTree)){
const persons=group.aggregatePersons||group.directPersons;

const numUnfilteredColSpans=this.getNumColumnsFor(persons.length,personHeight,heatmapHeight);
leafColSpans.push(numUnfilteredColSpans);

let numFilteredColSpans=numUnfilteredColSpans;
if(useFilter){
const filteredPersonsInGroup=persons.filter(function(p){return filteredPersonIds.includes(p.id)});
numFilteredColSpans=this.getNumColumnsFor(filteredPersonsInGroup.length,personHeight,heatmapHeight);
}
filteredLeafColSpans.push(numFilteredColSpans);
};

return{leafColSpans:leafColSpans,filteredLeafColSpans:filteredLeafColSpans};
};HeatmapService.prototype.

getNumColumnsFor=function getNumColumnsFor(numPersons,personHeight,heatmapHeight){
if(personHeight>heatmapHeight){
throw new Error('personHeight cannot be greater than heatmapHeight.');
}
const maxPersonsPerColumn=Math.floor(heatmapHeight/personHeight);
const maxPersonAreaHeight=maxPersonsPerColumn*personHeight;
return Math.ceil(personHeight*numPersons/maxPersonAreaHeight)||1;
};HeatmapService.prototype.

getLongestNamesByDepth=function getLongestNamesByDepth(groupTree){
const maxAvailableDepth=this.getMaxAvailableDepth(groupTree);

let longestNamesByDepth={};
_walkTreeFromRoot(groupTree,function(group,currentDepth){
const longestNameAtDepth=longestNamesByDepth[currentDepth];

if(!_.exists(longestNameAtDepth)||group.name.length>longestNamesByDepth.length){
longestNamesByDepth[currentDepth]=group.name;
}

if(currentDepth===maxAvailableDepth){
const persons=group.aggregatePersons||group.directPersons;
for(const person of persons){
if(!_.exists(longestNamesByDepth.person)||person.name.length>longestNamesByDepth.person.length){
longestNamesByDepth.person=person.name;
}
}
}
});

return longestNamesByDepth;
};HeatmapService.prototype.

getMaxNumPersonsInLeafGroups=function getMaxNumPersonsInLeafGroups(groupTree){
return _.max(this.getLeafGroups(groupTree).
map(function(g){return _.exists(g.aggregatePersons)?
g.aggregatePersons.length:
g.directPersons.length}));
};HeatmapService.prototype.

getWithDirectPersonsMovedToPseudoGroupAtDepth=function getWithDirectPersonsMovedToPseudoGroupAtDepth(parentGroup,depth){
const clonedGroup=HeatmapGroupViewModel.cloneFromGroupStatisticsViewModel(parentGroup);

if(depth===0){
return clonedGroup;
}

const{directPersons:directPersons,children:children}=clonedGroup;

if(children.length>0&&directPersons.length===0&&depth>0){
return clonedGroup;
}

let lastChild;
let currentDepth=depth;
while(currentDepth-->0){
if(!_.exists(lastChild)){
lastChild=new PseudoGroup({
directPersons:directPersons,
name:_getNameForDepth(currentDepth),
parentGroupName:clonedGroup.name,
parentGroupId:clonedGroup.id});


continue;
}

lastChild=new PseudoGroup({
name:_getNameForDepth(currentDepth),
parentGroupName:clonedGroup.name,
parentGroupId:clonedGroup.id,
children:[lastChild]});

}

clonedGroup.children=children.concat([lastChild]);

return clonedGroup;
};HeatmapService.prototype.

constructHeatmapViewModelTree=function constructHeatmapViewModelTree(groupTree){var _this3=this;
const maxAvailableDepth=this.getMaxAvailableDepth(groupTree);

let newTree={};
_walkTreeFromRoot(groupTree,function(group,currentDepth,currentPath){
const distanceFromBottom=maxAvailableDepth-currentDepth;
const newGroup=_this3.getWithDirectPersonsMovedToPseudoGroupAtDepth(group,distanceFromBottom);
if(currentPath===''){
newTree=newGroup;
return;
}

_.set(newTree,currentPath,newGroup);
});

return newTree;
};HeatmapService.prototype.

getGroupBreadcrumbs=function getGroupBreadcrumbs(selectedGroup,rootGroup){
let breadcrumbs=[];

_climbTreeFromChildren(rootGroup,function(currentGroup,currentDepth,currentPath){
for(const crumb of breadcrumbs){
if(currentGroup.children.map(function(g){return g.id}).includes(crumb.id)){
breadcrumbs.push(currentGroup);
return;
}
}
if(currentGroup.id===selectedGroup.id){
breadcrumbs.push(currentGroup);
}
});

return breadcrumbs.reverse();
};return HeatmapService}(BaseService);


function _getNameForDepth(depth){
return depth===0?'--':'';
}

function _walkTreeFromRoot(group,fn){let currentDepth=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0;let currentPath=arguments.length>3&&arguments[3]!==void 0?arguments[3]:'';
fn(group,currentDepth,currentPath);

const nextDepth=currentDepth+1;
if(nextDepth>MaxDepth){
return;
}

for(const[index,child]of group.children.entries()){
_walkTreeFromRoot(child,fn,nextDepth,currentPath+`${currentDepth>0?'.':''}children.${index}`);
}
}

function _climbTreeFromChildren(group,fn){let currentDepth=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0;let currentPath=arguments.length>3&&arguments[3]!==void 0?arguments[3]:'';
const nextDepth=currentDepth+1;

if(group.children.length>0){
for(const[index,child]of group.children.entries()){
_climbTreeFromChildren(child,fn,nextDepth,currentPath+`${currentDepth>0?'.':''}children.${index}`);
}
}

fn(group,currentDepth,currentPath);
}

module.exports=HeatmapService;
module.exports.MaxDepth=MaxDepth;
//# sourceMappingURL=heatmapService.js.map
